// 环境常量
export const ENV = {
  DEV: 'dev',
  TEST: 'test',
  STG: 'stg',
  PROD: 'prod',
}
// 环境映射
export const envMap = {
  dev: 'QA',
  test: 'SIT',
  stg: 'STG',
  prod: 'PROD',
}

export const getEnvCode = () => {
  // 0 dev 1 test 2 stg 3 prod
  let url = location.href;
  let code;
  if (
    url.indexOf('-dev.') !== -1 ||
    url.indexOf('127.0.0.1') !== -1
  ) {
    code = 0;
  } else if (
    url.indexOf('-test.') !== -1 ||
    url.indexOf('localhost') !== -1
  ) {
    code = 1;
  } else if (url.indexOf('-stg.') !== -1) {
    code = 2;
  } else {
    code = 3;
  }
  return code;
}

export const getEnv = () => {
  switch (getEnvCode()) {
    case 0:
      return ENV.DEV;
    case 1:
      return ENV.TEST;
    case 2:
      return ENV.STG;
    case 3:
      return ENV.PROD;
    default:
      return ENV.PROD;
  }
}


